export default __webpack_public_path__ + "static/media/dashboard.4135d933.svg";